/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IFamilias from './entidades/familias';
import IFiltrosFamilia from './entidades/filtrosFamilia';

export default class ModeloFamilias {
    public consultarFamilias() {
        return manejadorRest<IRespuesta<IFamilias>>(() => negocio.get('Familia/ConsultarListaFamilia'), true);
    }
    public crearFamilias(familias: IFamilias) {
        return manejadorRest<IRespuesta<IFamilias>>(() => negocio.post('Familia/GuardarFamilia', familias), true);
    }
    public editarFamilias(familias: IFamilias) {
        return manejadorRest<IRespuesta<IFamilias>>(() => negocio.put('Familia/EditarFamilia', familias), true);
    }
    public eliminarFamilias(familias: IFamilias) {
        return manejadorRest<IRespuesta<IFamilias>>(() => negocio.delete('Familia/EliminarFamilia', familias), true);
    }
    public consultarListaFamiliasPorFiltro(filtrosFamilia: IFiltrosFamilia) {
        return manejadorRest<IRespuesta<IFamilias>>(
            () => negocio.post('Familia/ConsultarListaFiltro', filtrosFamilia),
            true
        );
    }
}
